<template>
    <section id="faq" class="section faq-area">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-12 col-md-10 col-lg-8">
                    <div class="section-heading text-center">
                        <span class="faq-kicker">{{ $t('faq.kicker') }}</span>
                        <h2>{{ $t('faq.heading') }}</h2>
                    </div>
                </div>
            </div>
            <div class="row">
                <div v-for="(item, index) in faqItems" class="col-12 col-lg-6" :key="index">
                    <button class="single-faq" :class="{ active: index === activeIndex }" @click="activeIndex = activeIndex === index ? -1 : index">
                        <div class="faq-question">
                            <h5>{{ item.question }}</h5>
                            <span>{{ index === activeIndex ? '-' : '+' }}</span>
                        </div>
                        <p v-if="index === activeIndex" v-html="item.answer"></p>
                    </button>
                </div>
            </div>
            <p class="faq-contact text-center">{{ $t('faq.contactPrefix') }} <a href="/contact">{{ $t('faq.contactLink') }}</a></p>
        </div>
        <!-- <div class="container">
            <div class="project-cta row align-items-center">
                <div class="col-12 col-lg-6">
                    <h2>{{ $t('faq.projectCtaTitle') }}</h2>
                    <p>{{ $t('faq.projectCtaDesc') }}</p>
                    <form class="project-form" @submit.prevent>
                        <input type="email" :placeholder="$t('faq.emailPlaceholder')">
                        <button type="submit">{{ $t('faq.subscribe') }}</button>
                    </form>
                </div>
                <div class="col-12 col-lg-6">
                    <div class="cta-screens">
                        <img src="assets/img/hero/screen_1.jpg" alt="">
                        <img src="assets/img/hero/screen_3.jpg" alt="">
                    </div>
                </div>
            </div>
        </div> -->
    </section>
</template>
<script>
export default {
    data() {
        return {
            activeIndex: 0
        }
    },
    computed: {
        faqItems() {
            return [
                {
                    answer: this.$t('faq.registerA'),
                    question: this.$t('faq.registerQ')
                },
                {
                    answer: this.$t('faq.uploadA'),
                    question: this.$t('faq.uploadQ')
                },
                {
                    answer: this.$t('faq.supportA'),
                    question: this.$t('faq.supportQ')
                },
                {
                    answer: this.$t('faq.inviteA'),
                    question: this.$t('faq.inviteQ')
                },
                {
                    answer: this.$t('faq.freeA'),
                    question: this.$t('faq.freeQ')
                },
                {
                    answer: this.$t('faq.changePlanA'),
                    question: this.$t('faq.changePlanQ')
                }
            ]
        }
    }
}
</script>
<style>
 .faq-area {
    background: #eef3f9;
    padding: 92px 0 80px;
}

.section-heading {
    margin-bottom: 48px;
}

.faq-kicker {
    color: var(--blue);
    display: block;
    font-size: 12px;
    font-weight: 800;
    margin-bottom: 14px;
    text-transform: uppercase;
}

.section-heading h2 {
    color: #111827;
    font-size: 42px;
    font-weight: 800;
}

.section-heading h2::after {
    display: none;
}

.single-faq {
    background: #fff;
    border: 0;
    border-radius: 8px;
    box-shadow: none;
    display: block;
    margin-bottom: 22px;
    padding: 22px 26px;
    text-align: left;
    width: 100%;
}

.single-faq::after {
    display: none;
}

.faq-question {
    align-items: center;
    display: flex;
    justify-content: space-between;
}

.faq-question h5 {
    color: #172033;
    font-size: 16px;
    font-weight: 800;
}

.faq-question span {
    align-items: center;
    background: #eef4ff;
    border-radius: 50%;
    color: var(--blue);
    display: inline-flex;
    font-size: 18px;
    font-weight: 800;
    height: 30px;
    justify-content: center;
    width: 30px;
}

.single-faq.active .faq-question span {
    background: var(--blue);
    color: #fff;
}

.single-faq p {
    color: #63708a;
    font-size: 14px;
    line-height: 1.7;
    margin-top: 16px;
}

.faq-contact {
    color: #4b5870;
    margin: 28px 0 76px;
}

.faq-contact a {
    color: var(--blue);
    font-weight: 800;
}

.project-cta {
    background: linear-gradient(110deg, #8d1bd1 0%, #b022cf 50%, #711bd2 100%);
    border-radius: 8px;
    min-height: 340px;
    overflow: hidden;
    padding: 58px 72px;
}

.project-cta h2 {
    color: #fff;
    font-size: 48px;
    font-weight: 800;
    line-height: 1.08;
    max-width: 500px;
}

.project-cta p {
    color: rgba(255, 255, 255, 0.75);
    font-size: 15px;
    margin: 22px 0;
}

.project-form {
    display: flex;
    gap: 14px;
    max-width: 520px;
}

.project-form input,
.project-form button {
    border: 0;
    border-radius: 8px;
    height: 52px;
}

.project-form input {
    flex: 1;
    padding: 0 24px;
}

.project-form button {
    background: #fff;
    color: #111827;
    font-weight: 800;
    padding: 0 32px;
}

.cta-screens {
    display: flex;
    gap: 24px;
    justify-content: flex-end;
}

.cta-screens img {
    border-radius: 14px;
    box-shadow: 0 24px 70px rgba(17, 24, 39, 0.24);
    max-height: 260px;
}

@media (max-width: 991px) {
    .project-cta {
        padding: 44px 34px;
    }

    .cta-screens {
        justify-content: center;
        margin-top: 36px;
    }
}

@media (max-width: 575px) {
    .section-heading h2,
    .project-cta h2 {
        font-size: 32px;
    }

    .project-form {
        flex-direction: column;
    }
}
</style>
